module.exports = __webpack_public_path__ + "static/media/UniNeueLight.f436bd5b.woff";